import { ROUTE_PATH_WIKI } from "page/wiki/wiki-config";

export const ROUTE_PATH_GAMEPLAY = `${ROUTE_PATH_WIKI}/gameplay`;
